/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q6Inputs */

const en_to_typescript_faq_q6 = /** @type {(inputs: To_Typescript_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it deduplicate identical nested shapes?`)
};

const ko_to_typescript_faq_q6 = /** @type {(inputs: To_Typescript_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구조가 같은 중첩 형태를 중복 제거하나요?`)
};

const ja_to_typescript_faq_q6 = /** @type {(inputs: To_Typescript_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`構造が同一のネストした形は重複解消されますか`)
};

/**
* | output |
* | --- |
* | "Does it deduplicate identical nested shapes?" |
*
* @param {To_Typescript_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q6 = /** @type {((inputs?: To_Typescript_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q6(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q6(inputs)
	return ja_to_typescript_faq_q6(inputs)
});